import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const services = [
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" className="w-10 h-10">
        <path d="M16 8C16 8 20 20 32 24C44 20 48 8 48 8" stroke="#C9956C" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M10 28C10 28 20 18 32 22C44 18 54 28 54 28" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" strokeDasharray="3 2" />
        <path d="M32 24V56" stroke="#C9956C" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M24 36C24 36 28 34 32 36C36 34 40 36 40 36" stroke="#6B2737" strokeWidth="2" strokeLinecap="round" />
        <path d="M22 46C22 46 27 44 32 46C37 44 42 46 42 46" stroke="#6B2737" strokeWidth="2" strokeLinecap="round" />
        <circle cx="32" cy="24" r="4" fill="#F5E6D3" stroke="#C9956C" strokeWidth="1.5" />
      </svg>
    ),
    title: 'Hair Braiding & Styling',
    desc: 'From intricate box braids to elegant updos — our stylists craft looks that turn heads across Abuja.',
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" className="w-10 h-10">
        <path d="M20 52C20 52 12 44 12 32C12 20 24 8 32 8C40 8 52 20 52 32C52 44 44 52 44 52" stroke="#C9956C" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M26 52C26 52 22 46 22 38C22 30 26 22 32 20C38 22 42 30 42 38C42 46 38 52 38 52" stroke="#6B2737" strokeWidth="2" strokeLinecap="round" />
        <ellipse cx="32" cy="40" rx="6" ry="10" fill="#F5E6D3" stroke="#C9956C" strokeWidth="1.5" />
        <path d="M28 20C28 20 30 16 32 14M36 20C36 20 34 16 32 14" stroke="#C9956C" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    title: 'Natural Hair Treatment',
    desc: 'Deep conditioning, hot oil treatments, and moisture-lock therapies to restore your hair\'s natural vitality.',
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" className="w-10 h-10">
        <circle cx="32" cy="28" r="16" fill="none" stroke="#C9956C" strokeWidth="2" />
        <path d="M22 28C22 28 26 20 32 20C38 20 42 28 42 28" stroke="#6B2737" strokeWidth="2" strokeLinecap="round" />
        <path d="M32 12V8M44 16L47 13M48 28H52M44 40L47 43M32 44V48M20 40L17 43M16 28H12M20 16L17 13" stroke="#C9956C" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="32" cy="28" r="6" fill="#F5E6D3" />
        <path d="M24 36C26 40 30 42 32 42C34 42 38 40 40 36" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" />
        <circle cx="26" cy="28" r="2" fill="#6B2737" />
        <circle cx="38" cy="28" r="2" fill="#C9956C" />
      </svg>
    ),
    title: 'Hair Coloring & Highlights',
    desc: 'Vibrant color, balayage, ombre, and precision highlights — applied with professional-grade products.',
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" className="w-10 h-10">
        <rect x="14" y="10" width="36" height="12" rx="6" fill="none" stroke="#C9956C" strokeWidth="2" />
        <path d="M14 22C14 22 12 32 16 42C18 46 24 50 32 50C40 50 46 46 48 42C52 32 50 22 50 22" stroke="#C9956C" strokeWidth="2" />
        <path d="M20 30C22 28 26 28 28 32" stroke="#F5E6D3" strokeWidth="2" strokeLinecap="round" />
        <path d="M36 30C38 28 42 28 44 32" stroke="#F5E6D3" strokeWidth="2" strokeLinecap="round" />
        <path d="M24 40C24 40 28 44 32 44C36 44 40 40 40 40" stroke="#6B2737" strokeWidth="2" strokeLinecap="round" />
        <circle cx="32" cy="16" r="3" fill="#F5E6D3" />
      </svg>
    ),
    title: 'Relaxer & Keratin Treatments',
    desc: 'Smooth, frizz-free hair with our expert relaxer applications and keratin smoothing treatments.',
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" className="w-10 h-10">
        <ellipse cx="32" cy="30" rx="18" ry="20" fill="none" stroke="#C9956C" strokeWidth="2" />
        <path d="M20 20C22 16 28 14 32 14C36 14 42 16 44 20" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" />
        <circle cx="26" cy="28" r="3" fill="none" stroke="#6B2737" strokeWidth="1.5" />
        <circle cx="38" cy="28" r="3" fill="none" stroke="#6B2737" strokeWidth="1.5" />
        <path d="M26 36C28 40 36 40 38 36" stroke="#6B2737" strokeWidth="2" strokeLinecap="round" />
        <path d="M14 26C10 26 8 30 10 34" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" />
        <path d="M50 26C54 26 56 30 54 34" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" />
        <path d="M28 14C28 10 30 8 32 8C34 8 36 10 36 14" stroke="#F5E6D3" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    title: 'Facials & Skincare',
    desc: 'Rejuvenating facials, deep cleansing, brightening, and anti-aging treatments for glowing Abuja skin.',
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" className="w-10 h-10">
        <path d="M16 36C16 28 20 20 28 18C32 17 36 18 40 20" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 42C12 38 14 34 18 32" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" />
        <rect x="20" y="36" width="28" height="18" rx="6" fill="none" stroke="#C9956C" strokeWidth="2" />
        <path d="M26 44H38M26 48H34" stroke="#6B2737" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="40" cy="24" r="8" fill="none" stroke="#F5E6D3" strokeWidth="2" />
        <path d="M36 24C36 22 38 20 40 20C42 20 44 22 44 24" stroke="#C9956C" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M38 28C39 30 41 30 42 28" stroke="#C9956C" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    title: 'Manicure & Pedicure',
    desc: 'Classic, gel, acrylic, and nail art — perfect hands and feet with premium products and care.',
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" className="w-10 h-10">
        <ellipse cx="32" cy="48" rx="20" ry="8" fill="none" stroke="#C9956C" strokeWidth="1.5" opacity="0.5" />
        <path d="M20 40C20 32 24 24 32 20C40 24 44 32 44 40" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" />
        <path d="M24 36C24 30 28 26 32 24C36 26 40 30 40 36" stroke="#6B2737" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M16 44C14 40 14 34 18 30" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" />
        <path d="M48 44C50 40 50 34 46 30" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" />
        <circle cx="32" cy="16" r="6" fill="none" stroke="#F5E6D3" strokeWidth="2" />
        <circle cx="32" cy="16" r="2.5" fill="#C9956C" />
        <path d="M28 12C30 8 34 8 36 12" stroke="#F5E6D3" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    title: 'Full Body Massage & Spa',
    desc: 'Swedish, deep tissue, and hot stone massages. Pure relaxation in our serene Wuse 2 sanctuary.',
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" className="w-10 h-10">
        <circle cx="32" cy="20" r="10" fill="none" stroke="#C9956C" strokeWidth="2" />
        <path d="M26 16C28 14 30 13 32 13C34 13 36 14 38 16" stroke="#C9956C" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M22 32C22 28 26 26 32 26C38 26 42 28 42 32" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" />
        <path d="M14 54C14 44 22 36 32 36C42 36 50 44 50 54" stroke="#6B2737" strokeWidth="2" strokeLinecap="round" />
        <path d="M6 30C8 26 14 24 18 28" stroke="#F5E6D3" strokeWidth="2" strokeLinecap="round" />
        <path d="M58 30C56 26 50 24 46 28" stroke="#F5E6D3" strokeWidth="2" strokeLinecap="round" />
        <path d="M8 42C6 38 8 32 12 32" stroke="#C9956C" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M56 42C58 38 56 32 52 32" stroke="#C9956C" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    title: 'Makeup & Bridal Packages',
    desc: 'Flawless bridal glam, event makeup, and complete beauty packages for your most important days.',
  },
];

function ServiceCard({ service, index }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 40 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className="group relative bg-white rounded-2xl p-7 cursor-default card-glow hover:-translate-y-2 transition-all duration-500 border border-champagne/60"
      style={{
        boxShadow: '0 4px 24px rgba(0,0,0,0.05)',
      }}
    >
      {/* Top accent line */}
      <div className="absolute top-0 left-6 right-6 h-0.5 rounded-full bg-gradient-to-r from-transparent via-roseGold to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

      {/* Icon wrapper */}
      <div className="w-16 h-16 rounded-2xl bg-champagne/60 flex items-center justify-center mb-5 group-hover:bg-roseGold/10 transition-colors duration-400">
        {service.icon}
      </div>

      <h3 className="font-playfair font-semibold text-lg text-dark mb-3 leading-snug">
        {service.title}
      </h3>
      <p className="font-inter text-sm text-charcoal/70 leading-relaxed mb-5">
        {service.desc}
      </p>

      <span className="inline-flex items-center gap-1.5 text-roseGold font-inter text-xs font-semibold tracking-wide uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Learn More
        <span className="group-hover:translate-x-1 transition-transform duration-200">→</span>
      </span>

      {/* Bottom decorative dot */}
      <div className="absolute bottom-5 right-5 w-1.5 h-1.5 rounded-full bg-roseGold/30 group-hover:bg-roseGold transition-colors duration-300" />
    </motion.div>
  );
}

export default function Services() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="services" className="py-24 lg:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div ref={ref} className="text-center mb-16">
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5 }}
            className="font-inter text-roseGold text-xs font-semibold tracking-[0.3em] uppercase mb-3"
          >
            What We Offer
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-playfair text-4xl md:text-5xl font-bold text-dark mb-5"
          >
            Our Services
          </motion.h2>
          <motion.div
            initial={{ scaleX: 0 }}
            animate={inView ? { scaleX: 1 } : {}}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="w-20 h-0.5 bg-gradient-to-r from-roseGold to-burgundy mx-auto mb-5"
          />
          <motion.p
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="font-inter text-charcoal/70 text-base max-w-xl mx-auto leading-relaxed"
          >
            From haircare to full-body spa — every service crafted with expertise and premium products.
          </motion.p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {services.map((service, i) => (
            <ServiceCard key={service.title} service={service} index={i} />
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center mt-14"
        >
          <a
            href="#booking"
            onClick={(e) => { e.preventDefault(); document.querySelector('#booking')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-roseGold to-roseGoldDark text-white font-inter font-semibold text-sm tracking-wide shadow-lg shadow-roseGold/30 hover:shadow-roseGold/50 hover:scale-105 transition-all duration-300"
          >
            Book Any Service
            <span>→</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
